
/**
 * Global Animation Controller
 * Uses Intersection Observer to trigger entrance animations.
 */
document.addEventListener('DOMContentLoaded', () => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Unobserve after animating in to save performance
        if (!entry.target.classList.contains('animate-repeat')) {
          observer.unobserve(entry.target);
        }
      }
    });
  }, options);

  // Initial scan for animatable elements
  const initAnimations = () => {
    const targets = document.querySelectorAll('.animate-on-scroll, .stagger-container, .scale-reveal, .hero-title-animate');
    targets.forEach(target => observer.observe(target));
  };

  initAnimations();

  // Re-run for dynamic content (optional but good for SPAs/hydration)
  document.addEventListener('shopify:section:load', initAnimations);
});
